<template>
  <div>
    <header-bar>
      スプリット
    </header-bar>
    <div
      v-if="renderContent"
      class="page-block">
      <div class="my-release-search-wrap">
        <revenue-share-top-section
          :title="product.title"
          :img-src="product.coverart_filepath"
          :artist-name="product.artist_name"
          :release-type="product.type"
          :date="product.created_at"
          :owner-email="ownerEmail" />
        <div>
          <h3>
            現在のステータス
          </h3>
          <div
            class="my-release-search-wrap"
            style="padding: 0">
            <revenue-share-detail-table
              :headers="tableHeader"
              :data="[rsData[0]]"
              :is-account-complete="isCompleteAccount"
              page-name="collaboratorDetailForAlbum" />
          </div>
        </div>
        <div
          v-for="(value, key) in rsData"
          :key="key">
          <div class="table-title">
            {{ `${key + 1}. ` }} {{ value['product_disc_tracks']['titles'][0]['title'] }}
          </div>
          <revenue-share-detail-table
            :headers="actionableTableHeader"
            :data="[value]"
            :is-account-complete="isCompleteAccount"
            page-name="collaboratorDetailForAlbum"
            @redirectToPage="redirectToPage" />
        </div>
        <div class="c-btn-wrap">
          <router-link
            :to="{name: 'revenue-share'}"
            class="c-btn c-btn--back">
            戻る
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left" />
          </router-link>
        </div>
      </div>
    </div>
    <account-information
      v-if="check && display === 'user-data-input'"
      :company-id="companyId"
      @showSection="show('confirm-user-data')" />
    <confirm-account-information
      v-if="check && display === 'confirm-user-data'"
      :company-id="companyId"
      @show="show" />
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'
import RevenueShareTopSection from './RevenueShareTopSection'
import RevenueShareDetailTable from './RevenueShareDetailTable'
import account from '../../mixins/account'
import AccountInformation from '../User/AccountInformation'
import ConfirmAccountInformation from '../User/ConfirmAccountInformation'

export default {
  name: 'CollaboratorDetailForAlbum',
  components: {
    HeaderBar,
    RevenueShareTopSection,
    RevenueShareDetailTable,
    AccountInformation,
    ConfirmAccountInformation,
  },
  mixins: [
    account,
  ],
  data() {
    return {
      rsData: [{
        code: ' ',
        rate: '',
        role: '',
        collaborator_id: '',
        company_id: '',
        created_at: '',
        deleted_at: '',
        updated_at: '',
        email: '',
        id: '',
        invitation_code: '',
        memo: '',
        owner: '',
        product_disc_track_id: '',
        product_disc_tracks: {
          product: {
            artist_name: '',
            id: '',
            title: '',
            coverart_filepath: '',
            type: '',
          },
          titles: [{
            title: '',
          }],
        },
      }],
      product: {},
      id: '',
      loading: false,
      route: '/client/revenue-share/confirm-revenue-share/',
      isCompleteAccount: false,
      renderContent: false,
      companyId: '',
      check: false,
      display: '',
      actionableTableHeader: [{
        name: '分配率',
        class: 'detail-table',
        isIcon: false,
        key: 'rate',
      },
      {
        name: 'メンバー',
        class: 'detail-table',
        isIcon: true,
        key: 'email',
      },
      {
        name: '役割',
        class: 'detail-table',
        isIcon: false,
        key: 'role.role',
      }],
      tableHeader: [{
        name: 'メンバー',
        class: 'detail-table',
        style: 'width: 35%',
        isIcon: true,
        key: 'email',
      },
      {
        name: 'ステータス',
        class: 'detail-table',
        isIcon: false,
        key: 'status',
        actionable: true,
      },
      {
        name: '送信日時',
        class: 'detail-table',
        isIcon: false,
        key: 'updated_at',
        pipe: 'formatDate',
        style: 'width: 25%',
      },
      {
        name: '有効期限',
        class: 'detail-table',
        isIcon: false,
        key: 'updated_at',
        pipe: 'addDaysToDate',
        style: 'width: 25%',
      }],
      ownerEmail: '',
    }
  },
  async mounted() {
    this.id = this.$route.params?.id
    const { productId } = JSON.parse(window.sessionStorage.getItem('split')) || {}
    // check whether current processing productId and id of query params match or not.
    if (!productId || parseInt(productId, 10) !== parseInt(this.id, 10)) {
      this.$router.push({ name: 'index' })
      return
    }
    const { data } = await this.getRevenueShareById(this.id)
    if (data.message || data.length === 0) {
      await this.$router.push({ name: 'revenue-share' })
      return
    }
    this.renderContent = true
    this.product = data[0].product_disc_tracks.product
    this.rsData = data
    await this.getOwner()
    this.companyId = this.$store.state?.auth?.company?.id
    this.userData = await this.getUser('split-detail')
    this.isCompleteAccount = this.checkIfUserDataAvailable(this.userData)
  },
  methods: {
    async getRevenueShareById(id) {
      return window.axios.get('/api/client/revenueShare/detail/collaborator', { params: { product_id: id } })
    },
    async getOwner() {
      const { data } = await window.axios.get('/api/client/revenueShare/collaborator/getOwner', { params: { product_disc_track_id: this.rsData[0].product_disc_track_id } })
      this.ownerEmail = data
    },
    redirectToPage(path) {
      if (!this.isCompleteAccount) {
        this.check = true
        this.renderContent = false
        this.display = 'user-data-input'
      } else if (path.includes('confirm-revenue-share')) {
        this.$router.push(path)
      } else this.$router.push(path)
    },
    // handle which content should be displayed in screen
    show(section = '') {
      this.display = section
    },
  },
}
</script>

<style scoped>
.my-release-search-wrap {
  height: inherit !important;
  display: block !important;
  background: white;
  border: 2px solid #e8e8e8;
}

button{
  min-width: 150px;
}

.page-block {
  min-width: auto;
  max-width: 1120px;
  margin-bottom: 40px;
  height: auto;
}

.info-title {
  font-size: 24px;
  font-weight: 600;
}

.info-sec font{
  font-size: 18px;
}

.top-info {
  margin: 24px 0;
}

.info-title {
  font-size: 26px;
  font-weight: 400;
}

.info-sec{
  font-size: 16px;
  color: #636363 !important;
  text-align: left;
}
.email-col{
  width: 35rem;
}

.rate-col{
  width: 10rem;
}

.status-col{
  width: 30rem;
}

.date-col{
  width: auto;
}
.table-title{
  font-size: 24px;
  font-weight: bold;
  padding-bottom: 2rem;
  margin-top: 30px;
}
</style>
